import axios from 'axios';

export const saveMaintenanceMode = (data) => {
    return axios.post('/api/admin/maintenance/mode', data);
};

export const saveMaintenanceHeadsup = (data) => {
    return axios.post('/api/admin/maintenance/headsup', data);
};

export const getMaintenanceSetting = () => {
    return axios.get('/api/admin/maintenance');
};
